import { Component, OnInit, HostListener, ElementRef, ViewChild, EventEmitter } from "@angular/core";
import { AppBaseComponent, AppService, AvoService, ReftagService, ScriptService, UsbDeviceService, WebCommunityService } from "@mypxplat/xplat/web/core";
import {
  UserService,
  HelperService,
  ProductService,
  environment,
  WorkspaceService,
  StorageService,
  StorageKeys,
  EventsService,
  OrderService,
  SupportService,
  WindowService,
  EventBusService,
  CheckoutService,
  LanguageService,
} from "@mypxplat/xplat/core";
import { takeUntil, take, filter } from "rxjs/operators";
import { Location } from "@angular/common";
import { CookieService } from "ngx-cookie-service";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { ApplicationUpdateComponent, GenericProductPurchase, LinkFenderAccountComponent, SwitchLanguageComponent, UpgradeSoftwareStripeComponent } from "@mypxplat/xplat/web/features";
import { signOut } from "aws-amplify/auth";
import Bugsnag from "@bugsnag/js";
@Component({
  selector: "myp-root",
  templateUrl: "./app.component.html",
  standalone: false,
})
export class AppComponent extends AppBaseComponent implements OnInit {
  @HostListener("window:beforeunload", ["$event"])
  doSomething($event) {
    this.workspaceService.uploadingFile$.pipe(take(1)).subscribe((result) => {
      if (result) $event.returnValue = "You are currently uploading a file, if you reload now it will be canceled.";
    });
  }

  sidebarClosed: boolean = false;
  myStyle: object = {};
  myParams: object = {};
  width: number = 100;
  height: number = 100;
  authNeeded: boolean = true;
  public env = environment;
  @ViewChild("appContainer") appContainer: ElementRef;
  public showHeader: boolean = false;
  public showLinkAccountNoticeIfNecessary: boolean = true;

  constructor(
    public userService: UserService,
    public helperService: HelperService,
    public productService: ProductService,
    public eventsService: EventsService,
    public orderService: OrderService,
    public supportService: SupportService,
    public appService: AppService,
    public workspaceService: WorkspaceService,
    public communityService: WebCommunityService,
    public fbAuth: AngularFireAuth,
    public spin: NgxSpinnerService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public avoService: AvoService,
    private _win: WindowService,
    private _location: Location,
    private _cookieService: CookieService,
    private _storageService: StorageService,
    private _translateService: TranslateService,
    private _scriptService: ScriptService,
    public eventBusService: EventBusService,
    public reftagService: ReftagService,
    public checkoutService: CheckoutService,
    public usbDeviceService: UsbDeviceService,
    private _languageService: LanguageService
  ) {
    super(userService);
    // this.appService.setTokensFromCookies();
    this.appService.app = "sphere";
    this.userService.appId = "sphere";
    this.eventBusService.observe(this.eventBusService.types.showNewCodeAlert).subscribe((result) => {
      this.appService.showModal(ApplicationUpdateComponent, { size: "lg" });
    });
  }

  setApplicationLanguage() {
    this._languageService.setApplicationLanguageFromParams(this.activatedRoute, this.user, (userId, languageCode) => this.userService.saveUserLanguage(userId, languageCode));
  }

  linkFenderAccount() {
    const modalRef = this.appService.showModal(LinkFenderAccountComponent, { size: "lg" });
  }

  ngOnInit() {
    window.addEventListener("unhandledrejection", (event) => {
      if (event?.reason?.message) Bugsnag.notify(event.reason.message);
    });
    this.appService.showLangSwitcher$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.appService.showModal(SwitchLanguageComponent, { size: "lg", ariaLabelledBy: "modal-title" });
    });
    this.appService.initTheme();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showHeader = !this.router.url.includes("/checkout") && !this.router.url.includes("/paymentmethod") && !this.router.url.includes("/onboarding") && !this.router.url.includes("/login"); // Hide header on checkout page
        this.setup();
      }
    });

    this.helperService.backPressed$.pipe(takeUntil(this.destroy$)).subscribe((result) => {
      this._location.back();
    });
  }

  setup() {
    const checkoutParamFlow = () => {
      this._win.setTimeout(() => {
        let checkoutUrlParam = this.activatedRoute.snapshot.queryParamMap.get("checkout");
        if (checkoutUrlParam && this.env.stripe.products[checkoutUrlParam]) {
          this.appService.goToCheckout(`/checkout?checkoutProductType=Generic&checkoutProductKey=${checkoutUrlParam}`, this.env.stripe.products[checkoutUrlParam].paeId);
        } else if (location.pathname == "/buy") {
          let productId;
          if (this.env.stripe.products[checkoutUrlParam] && this.env.stripe.products[checkoutUrlParam].paeId) productId = this.env.stripe.products[checkoutUrlParam].paeId;
          let checkoutProductType = "Perpetual";
          if (checkoutUrlParam) checkoutProductType = "Generic";
          if (checkoutProductType == "Perpetual" && !productId) {
            this.checkoutService.getUpgradableProducts().subscribe((result) => {
              productId = result.data?.products?.length ? result.data.products[0].id : null;
              this.appService.goToCheckout(`/checkout?checkoutProductType=${checkoutProductType}${checkoutUrlParam ? "&checkoutProductKey=" + checkoutUrlParam : ""}`, productId);
            });
          } else {
            this.appService.goToCheckout(
              `/checkout?checkoutProductType=${checkoutProductType}${checkoutUrlParam ? "&checkoutProductKey=" + checkoutUrlParam : ""}`,
              this.env.stripe.products[checkoutUrlParam] ? this.env.stripe.products[checkoutUrlParam].paeId : null
            );
          }
        }
      }, 1000);
    };
    if (!this.router.url.includes("/checkout") && !this.router.url.includes("/paymentmethod") && !this.router.url.includes("/login") && !this.router.url.includes("/logout")) {
      this.avoService.initAvoFunctions(environment.avo.apiKey, "Studio One+", "1.0.0");
      //if (this.env.features.cookie_management) this._scriptService.loadScript(environment.usercentricsScriptId);
      if (this.env.features.cookie_management) this._scriptService.loadScript("osano");
      this._scriptService.loadScript("stripe");
      if (this.user) {
        this.setApplicationLanguage();
        this.communityService.getFirebaseProfile();
        this.avoService.avoInitted$.pipe(filter((result) => !!result)).subscribe((result) => {
          if (!this._storageService.checkTimestamp("logged_in_event_triggered")) {
            this.avoService.trackEvent().loggedIn({
              userId_: this.user.id,
              prsId: this.user.id,
              siteId: this.user.active_subscription ? "studio_one_plus" : "mypresonus",
            });
            this._storageService.setTimestamp("logged_in_event_triggered", 24);
          }
          if (this._storageService.getItem(StorageKeys.CHECKOUT_COMPLETED_DATA)) {
            this.avoService.trackEvent().orderCompleted(this._storageService.getItem(StorageKeys.CHECKOUT_COMPLETED_DATA));
            this._storageService.removeItem(StorageKeys.CHECKOUT_COMPLETED_DATA);
          }
        });
        checkoutParamFlow();
      } else {
        this.userService.user$
          .pipe(
            filter((user) => !!user),
            take(1)
          )
          .subscribe((result) => {
            this.communityService.getFirebaseProfile();
            checkoutParamFlow();
          });
      }
    } else if (this.router.url.includes("/login") || this.router.url.includes("/logout")) {
      this.avoService.initAvoFunctions(environment.avo.apiKey, "Studio One+", "1.0.0");
    }
  }

  ngAfterViewInit() {
    this.appService.appContainer = this.appContainer.nativeElement;
  }
}
